const buildPersonFields = (data) => ({
  FirstName: data.FirstName || null,
  MiddleName: data.MiddleName || null,
  LastName: data.LastName || null,
  FullName: [data.FirstName, data.MiddleName, data.LastName].filter(Boolean).join(' '),
  NickName: data.NickName || null,
  Prefix: data.Prefix || null,
  Suffix: data.Suffix || null,
  GeneralAppearance: data.GeneralAppearance || null,
  Race: data.Race || null,
  Sex: data.Sex || null,
  Height: data.Height || null,
  Weight: data.Weight || null,
  Born: data.Born || null,
  ptsBirthCityID: data.ptsBirthCityID || null,
  BirthCounty: data.BirthCounty || null,
  BirthState: data.BirthState || null,
  BirthCountry: data.BirthCountry || null,
  Deceased: data.Deceased,
  Died: data.Died || null,
  CauseOfDeath: data.CauseOfDeath || null,
  LocalResident: data.LocalResident || null,
  IsUSCitizen: data.IsUSCitizen,
  CurrentCitizenship: data.CurrentCitizenship || null,
  BirthCitizenship: data.BirthCitizenship || null,
  BirthNationality: data.BirthNationality || null,
  Gang: data.Gang || null,
  MaritalStatus: data.MaritalStatus || null,
  EducationLevel: data.EducationLevel || null,
  Allergies: data.Allergies || null,
  DNA: data.DNA || null,
  Notes: data.Notes || null,
  PrimaryLanguage: data.PrimaryLanguage || null,
  WhyDangerous: data.WhyDangerous || null,
  PrintsAvailable: data.PrintsAvailable,
  OverrideJuvenile: data.OverrideJuvenile,
  PublicOfficial: data.PublicOfficial,
  HasDigitalImage: data.HasDigitalImage,
  Incarcerated: data.Incarcerated,
  ConcealedWeaponPermit: data.ConcealedWeaponPermit,
  Dangerous: data.Dangerous,
  IsOrganDonor: data.IsOrganDonor,
  ExFelon: data.ExFelon,
  ProtectiveOrder: data.ProtectiveOrder,
  SeniorCitizen: data.SeniorCitizen,
  Officer: data.Officer,
  SexOffender: data.SexOffender,
  Juvenile: data.Juvenile,
  Military: data.Military,
  Probation: data.Probation,
  Ethnicity: data.Ethnicity || null,
  EyeColor: data.EyeColor || null,
  Handed: data.Handed || null,
  BloodType: data.BloodType || null,
  HairColor: data.HairColor || null,
  HairLength: data.HairLength || null,
  HairStyle: data.HairStyle || null,
  EnglishLangIndicator: data.EnglishLangIndicator,
  HasDigitizedSignatureImage: false,
});

export const buildPersonPayload = (data) => ({
  application: 'rms',
  person: buildPersonFields(data),
  contact: {
    ContactMethod: data.ContactMethodType || null,
    MethodType: data.ContactType || null,
    Info: data.ContactInfo || null,
    IsDefault: data.IsDefaultContact,
    Notes: data.ContactNotes || null,
    ptsAddressID: data.ptsAddressID || null,
    IsPrimary: data.IsPrimaryAddress,
    PartyType: 'Person',
  },
  credentials: {
    SSN: data.SSN || null,
    OLN: data.OLN || null,
    State: data.OLNState || null,
  },
});

export const buildEditPersonPayload = (data) => ({
  application: 'rms',
  person: buildPersonFields(data),
});
